window.LOCATION_FILTER_TYPE = {
    ALL_LEVELS: 'ALL_LEVELS',
    CHILDREN_ONLY: 'CHILDREN_ONLY',
};

window.RISK_ACCESS_MODE = {
    ALL: 'ALL',
    SINGLE: 'SINGLE'
};

window.RISK_ACTIVATION_TYPE = {
    LITE: 'LITE',
    FULL: 'FULL'
};

